import angular from 'angular';

class ExpertisesTableController {
  constructor(Vendor, Technology) {
    'ngInject';

    this.Vendor = Vendor;
    this.Technology = Technology;
  }

  $onInit() {
    this.proficiencies = angular.copy(this.proficiencies);

    this.loadVendors();
    this.loadTechnologies();
  }

  loadVendors() {
    return this.Vendor.query().$promise
      .then((response) => {
        this.vendors = response.vendors;
      })
  }

  loadTechnologies() {
    return this.Technology.query().$promise
      .then((response) => {
        this.technologies = response.technologies;
      })
  }

  loadSubTechnologies(technologyId) {
    this.sub_technologies = [];

    return this.Technology.subTechnologies({ technologyId }).$promise
      .then((response) => {
        this.sub_technologies = response.sub_technologies;
      })
      .catch(() => {
        this.sub_technologies = [];
      })
  }

  toggleNewProficiency() {
    const newProficiency = this.proficiencies.find((proficiency) => {
      return !proficiency.id;
    })

    if (newProficiency) {
      this.proficiencies.pop();
    } else {
      this.proficiencies.push({editing: true});
    }
  }

  handleProfileSave() {
    this.proficiencies.forEach((proficiency) => {
      proficiency.editing = false;
    })

    this.updating = true;
    if (this.onProfileSave) {
      this.onProfileSave({proficiencies: this.proficiencies})
      .then(() => {
        this.updating = false;
      })
      .catch((response) => {
        this.updating = false;
        this.errors = response.data.errors;
      });
    } else {
      this.updating = false;
    }
  }

  handleProficiencyDelete(proficiency) {
    proficiency['_destroy'] = true;
  }
}

export default ExpertisesTableController;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/components/expertises-table/expertises-table.controller.js